import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import SearchBox from './SearchBox';

const navItems = [
  { to: '/', label: '首页' },
  { to: '/category', label: '分类' },
  { to: '/search', label: '搜索' },
  { to: '/about', label: '关于' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative text-sm font-medium whitespace-nowrap transition cursor-pointer hover:text-accent-700 ${
      isActive ? 'text-accent-700' : 'text-foreground-800'
    }`;

  return (
    <header className="fixed top-0 left-0 z-50 w-full border-b border-background-200 bg-background-50/90 backdrop-blur-md">
      <div className="mx-auto flex h-16 w-full items-center gap-4 px-4 md:px-8">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-50 dark:text-foreground-950">
            <i className="ri-clapperboard-fill text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="text-base font-bold tracking-wide text-foreground-950">人间中毒在线</span>
            <span className="text-[10px] tracking-[0.25em] text-foreground-500">CINEMA ONLINE</span>
          </span>
        </Link>

        <nav className="ml-6 hidden items-center gap-7 md:flex">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === '/'}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto hidden w-full max-w-xs lg:block">
          <SearchBox size="sm" />
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((prev) => !prev)}
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-900 transition hover:bg-background-100 cursor-pointer md:ml-0 lg:hidden"
        >
          <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-3-line text-xl'}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-100 px-4 pb-5 pt-4 anim-fade-in md:hidden">
          <div className="mb-4 lg:hidden">
            <SearchBox size="md" />
          </div>
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `flex items-center justify-between rounded-lg px-3 py-3 text-sm font-medium transition ${
                    isActive ? 'bg-accent-100/20 text-accent-700' : 'text-foreground-800 hover:bg-background-200/60'
                  }`
                }
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-foreground-500"></i>
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}